var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var paramChecker = function (callback) {
    return function (target, key, descripter) {
        return {
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (callback.apply(void 0, __spreadArrays([this, key], args))) {
                    return descripter.value.apply(this, args);
                }
                return null;
            }
        };
    };
};
export default paramChecker;
